import React, { Component } from 'react';
import {Link} from "react-router-dom";

class Playground extends Component {

    render() {
        return (
            <div data-id={`${this.props.sideImage}`} className="swiper-slide">
                <div className={`side_image side_image-${this.props.sideImage}`}/>
                <div className="playground-page page">
                    <div className="playground__content page__content visible-content">
                        <h2>Besonderheit Kinderspielplatz</h2>
                        <p className="closed-notice">Vorübergehend geschlossen</p>
                        <div className="page_description">
                            <p>
                                Playground content
                            </p>
                        </div>
                        <Link to="/fuhlen" className="btn">
                            <div className="front">Fühlen Sie sich wohl</div>
                            <div className="back">Fühlen Sie sich wohl</div>
                        </Link>
                    </div>
                </div>
            </div>
        )
    }
}

export default Playground;
